module.exports = __webpack_public_path__ + "static/media/home_banner3.5d5d645f.png";